import { SET_LISTA_CATALOGUES, RESET_LISTA_CATALOGUES, SET_SELECTED_CATALOGUE, SET_SELECTED_CATALOGUES } from './types';

export const setListaCatalogues = (catalogues) => {
    // Salva i catalogues in localStorage come backup
    localStorage.setItem("catalogues", JSON.stringify(catalogues));

    return {
        type: SET_LISTA_CATALOGUES,
        payload: catalogues
    };
};

export const resetListaCatalogues = () => ({
    type: RESET_LISTA_CATALOGUES
});

export const setSelectedCatalogue = (catalog) => (dispatch) => {
    // Gestisce solo i campi effettivamente presenti nell'oggetto catalogo
    const serializedCatalog = {
        ...catalog,
        appIdIos: catalog.appIdIos || "",
        appPackage: catalog.appPackage || "",
        appPackageIos: catalog.appPackageIos || "",
        codePath: catalog.codePath || "",
        dataConsumption: catalog.dataConsumption || "",
        descriptionEn: catalog.descriptionEn || "",
        descriptionIt: catalog.descriptionIt || "",
        hdrEnvironment: catalog.hdrEnvironment || "",
        isPublic: catalog.isPublic !== undefined ? catalog.isPublic : true,
        list_service: catalog.list_service || [],
        nameCatalog: catalog.nameCatalog || "Unnamed Catalog",
        showSingleDotList: catalog.showSingleDotList !== undefined ? catalog.showSingleDotList : false,
        skin: catalog.skin || "",
        storage_consumption: catalog.storage_consumption || { consumption: 0, modelsNumber: 0 },
        takePicTemplate: catalog.takePicTemplate || "",
        urlLogo: catalog.urlLogo || "",
        webDomain: catalog.webDomain || "",
        webUrl: catalog.webUrl || ""
    };

    dispatch({
        type: SET_SELECTED_CATALOGUE,
        catalog: serializedCatalog
    });
};

// Nuova azione per gestire la selezione di più cataloghi
export const setSelectedCatalogues = (catalogs) => (dispatch) => {
    if (!Array.isArray(catalogs)) {
        console.error("setSelectedCatalogues: catalogs deve essere un array");
        return;
    }

    const serializedCatalogs = catalogs.map(catalog => ({
        ...catalog,
        appIdIos: catalog.appIdIos || "",
        appPackage: catalog.appPackage || "",
        appPackageIos: catalog.appPackageIos || "",
        codePath: catalog.codePath || "",
        dataConsumption: catalog.dataConsumption || "",
        descriptionEn: catalog.descriptionEn || "",
        descriptionIt: catalog.descriptionIt || "",
        hdrEnvironment: catalog.hdrEnvironment || "",
        isPublic: catalog.isPublic !== undefined ? catalog.isPublic : true,
        list_service: catalog.list_service || [],
        nameCatalog: catalog.nameCatalog || "Unnamed Catalog",
        showSingleDotList: catalog.showSingleDotList !== undefined ? catalog.showSingleDotList : false,
        skin: catalog.skin || "",
        storage_consumption: catalog.storage_consumption || { consumption: 0, modelsNumber: 0 },
        takePicTemplate: catalog.takePicTemplate || "",
        urlLogo: catalog.urlLogo || "",
        webDomain: catalog.webDomain || "",
        webUrl: catalog.webUrl || ""
    }));

    dispatch({
        type: SET_SELECTED_CATALOGUES,
        catalogs: serializedCatalogs
    });
}; 